import { render } from "./form_button.vue?vue&type=template&id=04b92d2d"
import script from "./form_button.vue?vue&type=script&lang=js"
export * from "./form_button.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployer/asset-portal/releases/20260828153143/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__